import { red } from '@mui/material/colors'
import { useState } from 'react'
import downArrow from '../../../assets/images/downArrow.svg'
import { getImageUrlFromName } from '../../../util'
import ViewAll from '../ViewAll'
import ExpandDetail from './ExpandDetail'
import rightArrow from '../../../assets/images/icons/see-all.svg'
import useHash from '../../common/customHooks/useHash'
import { useEffect } from 'react'

const BulletListLayout = ({ layout, value, handleDetailPageClose }) => {
  let imageUrl = getImageUrlFromName(layout.icon_name)
  const [seeAll, setseeAll] = useState(false)
  const showAll = () => {
    setseeAll(!seeAll)
  }

  // dialogues box
  const [open, setOpen] = useState(false)

  const handleExpandPageOpen = () => {
    setOpen(true)
  }

  const handleExpandPageClose = () => {
    setOpen(false)
  }
  //----

  return (
    <div
      style={{
        padding: '24px 20px 24px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#00ff00',
      }}
    >
      <div>
        <img src={imageUrl} alt="" style={{ width: '100px', height: 'auto' }} />
      </div>
      <div
        style={{
          marginTop: '16px',
          marginBottom: '24px',
          textAlign: 'left',
          color: 'var(--gray100)',
        }}
      >
        <p className="headline1">{layout.display_name}</p>
      </div>
      <ul
        style={{
          padding: '0 20px 0 20px',
        }}
      >
        {value.map((item, index) => {
          if (index <= 4) {
            return (
              <li
                style={{
                  textAlign: 'left',
                  color: 'var(--gray80)',
                }}
              >
                <p
                  className="body2"
                  style={{ margin: '16px 0px 16px 8px', lineHeight: '150%' }}
                >
                  {item}
                </p>
              </li>
            )
          }
        })}
      </ul>
      {value.length > 5 && (
        <div
          onClick={() => {
            handleExpandPageOpen()
          }}
          style={{
            color: 'var(--primaryShades20)',
            cursor: 'pointer',
            marginTop: '24px',
          }}
          className="headline2"
        >
          {/* <ViewAll top={'24px'}>See all</ViewAll> */}
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span>See all</span>
            <img src={rightArrow} alt="more"></img>
          </span>
        </div>
      )}
      {layout.display_name === 'Important info' && (
        <>
          <ExpandDetail
            open={open}
            handleExpandPageClose={handleExpandPageClose}
            handleDetailPageClose={handleDetailPageClose}
            value={value}
            layout={layout}
            contentType={layout.display_name}
          />
        </>
      )}
    </div>
  )
}

export default BulletListLayout
